/**
 * @module:  新建新开页按钮
 * @author: Liang Huang
 * @date: 2019-11-13 10:49:27
 */
import React, { CSSProperties } from 'react';
import './style.less';
import { observer } from 'mobx-react-lite';

const PlusBtn = observer((props: { url: string; style?: CSSProperties; callback?: () => void }) => {
  return (
    <span
      className="plus-btn"
      style={props.style}
      onClick={() => {
        props.callback && props.callback();
        if (process.env.NODE_ENV === 'development') {
          window.location.href = props.url;
        } else {
          window.YwkHybrid.page.open({
            pageUrl: props.url
          });
        }
      }}
    ></span>
  );
});

export default PlusBtn;
